import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setEmail as setStoreEmail } from "../../store/authSlice";
import AuthGeneralInput from "../../components/input/authinput";
import { AppButton } from "../../components/buttons/button";
import { H1Title, Paragraph } from "../../components/typography/typography";
import AuthService from "../../services/authService";
import { Success, Error as ToastError } from "../../components/toast/toast";
import _route from "../../constants/routes";

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      ToastError('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      await AuthService.forgotPassword({ email });
      dispatch(setStoreEmail(email));
      Success('Reset code sent! Check your email.');
      navigate(_route._reset_password);
    } catch (err) {
      ToastError(err.response?.data?.error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full space-y-5">
      <div>
        <H1Title size="sm">Forgot Password</H1Title>
        <Paragraph size="base" className="text-grey-667 mt-1">
          Enter your email and we'll send you a reset code.
        </Paragraph>
      </div>

      <AuthGeneralInput
        label="Email"
        type="email"
        name="email"
        placeholder="Enter your email"
        value={email}
        change={(e) => setEmail(e.target.value)}
      />

      <AppButton type="submit" loading={loading}>
        Send Reset Code
      </AppButton>

      <p className="text-sm text-center text-grey-667">
        Remember your password?{' '}
        <Link to={_route._login} className="text-primary font-semibold hover:underline">
          Sign In
        </Link>
      </p>
    </form>
  );
}
